/* eslint-disable import/prefer-default-export */

export const getImageSrc = (url?: string, width?: number) => {
  if (!url) return null;

  const src = new URL(url.startsWith("//") ? `https:${url}` : url);
  src.searchParams.set("w", width?.toString() || "64");
  src.searchParams.set("fm", "webp");

  return src.toString();
};
